import { render, staticRenderFns } from "./layout-card.vue?vue&type=template&id=51bbeef2&"
import script from "./layout-card.vue?vue&type=script&lang=js&"
export * from "./layout-card.vue?vue&type=script&lang=js&"
import style0 from "./layout-card.vue?vue&type=style&index=0&id=51bbeef2&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports